import { createFileRoute } from '@tanstack/react-router'
import SelectionListsContainer from 'SelectionList/containers/SelectionListsContainer'
import { claimTypesEnum } from 'User/utils/claims'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'

export const Route = createFileRoute('/contacts/lists')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_contacts]}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="main" />}>
                <SelectionListsContainer />
            </Suspense>
        </Guard>
    ),
})
